import React from 'react';
import { Divider } from 'components/ui';
import FrameworkUtils from 'utils/framework';

const { wrapFunctionalComponent } = FrameworkUtils;

function SectionDivider({ marginY = 5, ...props }) {
    return (
        <Divider
            color={['nearWhite', 'lightGray']}
            height={[3, 1]}
            marginX={['-container', 0]}
            marginY={marginY}
            {...props}
        />
    );
}

export default wrapFunctionalComponent(SectionDivider, 'SectionDivider');
